import { render, staticRenderFns } from "./VendorRepresentativeForm.vue?vue&type=template&id=d9ada7f6&"
import script from "./VendorRepresentativeForm.vue?vue&type=script&lang=js&"
export * from "./VendorRepresentativeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports